import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../components/Hero";
import Header from "../components/Header";
import ServicesSection from "../components/Services";
import AboutUs from "../components/About";
import Portfolio from "../components/Portfolio";
import HowWeWork from "../components/HowWeWork";
import TeamSection from "../components/TeamSection";
import PricingSection from "../components/PricingSection";
import TestimonialsSection from "../components/Testimonials";
import FaqSection from "../components/FAQSection";
import InsightsSection from "../components/Insights";
import ContactSection from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToHash = () => {
      const hash = location.hash.replace("#", "");
      if (!hash) return;

      const element = document.getElementById(hash);
      if (element) {
        const headerHeight = 80;
        const y =
          element.getBoundingClientRect().top + window.scrollY - headerHeight;

        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    };

    // Delay slightly to ensure layout is rendered
    setTimeout(scrollToHash, 100);
  }, [location.hash]);

  return (
    <div className="relative">
      <Header />
      <main>
        <section id="home">
          <HeroSection />
        </section>
        <section id="services">
          <ServicesSection />
        </section>
        <section id="about">
          <AboutUs />
        </section>
        <section id="portfolio">
          <Portfolio />
        </section>
        <section id="how-we-work">
          <HowWeWork />
        </section>
        <section id="team">
          <TeamSection />
        </section>
        {/* <section id="pricing">
          <PricingSection />
        </section> */}
        <section id="testimonials">
          <TestimonialsSection />
        </section>
        <section id="faq">
          <FaqSection />
        </section>
        <section id="insights">
          <InsightsSection />
        </section>
        <section id="contact">
          <ContactSection />
        </section>
      </main>
      <a
        href="https://wa.me/923487172565?text=Hello%20SafoLife"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 left-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition"
        title="Chat on WhatsApp"
      >
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.21.588 4.27 1.607 6.058l-1.607 5.942 5.942-1.607C7.73 23.412 9.79 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm6.36 17.36c-.36.36-.84.56-1.36.56-.48 0-.88-.2-1.2-.56l-1.68-1.68c-.36-.36-.56-.84-.56-1.36 0-.48.2-.88.56-1.2l1.68-1.68c.36-.36.84-.56 1.2-.56.48 0 .88.2 1.2.56l1.68 1.68c.36.36.56.84.56 1.36 0 .48-.2.88-.56 1.2l-1.68 1.68zm-4.36-4.36c-.36.36-.84.56-1.36.56-.48 0-.88-.2-1.2-.56l-1.68-1.68c-.36-.36-.56-.84-.56-1.36 0-.48.2-.88.56-1.2l1.68-1.68c.36-.36.84-.56 1.2-.56.48 0 .88.2 1.2.56l1.68 1.68c.36.36.56.84.56 1.36 0 .48-.2.88-.56 1.2l-1.68 1.68z" />
        </svg>
      </a>
      <Footer />
    </div>
  );
};

export default HomePage;
